/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
/* Define the cart component */
import React from "react";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import { useNavigate, useLocation } from "react-router-dom";
import { getCart } from "./CartSlice";
import config from "../../config/config"

function CartCard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const itemsInCart = useSelector((state) => state.cart.data);
  return (
    <Grid
      item
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        align: "center",
      }}
    >
      {config.homeView?.toUpperCase() === "WELCOME_VIEW" &&
      <Button
        size='medium'
        variant='contained'
        sx={{
          background: itemsInCart.length > 0 ? "#76B900" : "#616161",
          borderRadius: "4px",
        }}
        startIcon={<LocalMallOutlinedIcon />}
        onClick={() => {
          if(location.pathname !== "/CART_VIEW") {
            dispatch(getCart());
            navigate("/CART_VIEW");
          }
        }}
      >
        <Box sx={{ display: { xs: "none", md: "inherit" } }}>
          My Order ({itemsInCart.length})
        </Box>
      </Button>
      }
    </Grid>
  );
}

export default CartCard;
